import styled, {keyframes} from "styled-components"
import { css } from "styled-components";
import { FaSquare } from "react-icons/fa"
import {AiOutlineFileSearch} from "react-icons/ai"
import {BiExit} from "react-icons/bi"

const MainBody = styled.div`
    background-color: ${(props) => props.theme.primaryBg};
    direction: ${(props) => props.theme.english ? "ltr" : "rtl"};
    font-family: ${props => props.theme.english ? "Roboto" : 'Vazir'};
    letter-spacing: 0.5px;
    height: 100%;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
    margin-top: 80px;
    padding-bottom: 24px;

  @media screen and (max-width: 768px){
    padding-bottom: 60px;
  }
`;

const Flex = styled.div`
  display: flex;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
`;

const FlexColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "fit-content"};
`;

const CFlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
  direction: ${props => props.direction};
`;



const FlexStart = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: ${props => props.width};
  height: ${props => props.height};
`


const FlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: ${props => props.width};
  height: ${props => props.height};
`


const CFlexStart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: ${props => props.width};
`

const CFlexBetween = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
`

const CFlexEnd = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
`


const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
`


const DText = styled.div`
  font-size: ${props => props.fontSize || "0.7rem"};
  color: ${props => props.color || props.theme.color};
  direction: ${props => props._type === "number" && "ltr"};
  font-family: ${props => props.type === "number" && "monospace"};
  
  @media screen and (max-width: 1400px){
    font-size: ${props => props.fontSize || "0.65rem"};
    letter-spacing: 0.8px;
  }
  
  @media screen and (max-width: 480px) {
    font-size: ${props => props.fontSize || "0.6rem"};
  }
`

const ColorText = styled(DText)`
  color: ${props => props.tradeType === 'buy' ? props.theme.mainGreen : props.theme.mainRed};
  margin: 2px 0;
`

const InvoiceText = styled(DText)`
  padding: 0 2px;
`


const HText = styled.div`
  font-size: ${props => props.fontSize || "0.9rem"};
  color: ${props => props.color || props.theme.color};
  direction: ${props => props._type === "number" && "ltr"};
  font-family: ${props => props.type === "number" && "monospace"};
  transition: all 0.3s;
  cursor: pointer;

  ${props => props.active && css`
    color: ${props => props.theme.mainOrange};
  `}

  &:hover{
    color: ${props => props.theme.mainOrange};
  }

  @media screen and (max-width: 1400px){
    font-size: ${props => props.fontSize || "0.8rem"};
  }

  @media screen and (max-width: 1050px) {
    font-size: ${props => props.fontSize || "0.7rem"};
  }
`


const TradeWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: ${props => props.padding || "15px"};
  display: flex;
`

const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.primaryBg};
`

const CFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "100%"};
`

const TradeBoxHeader = styled.div`
  display: flex;
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.color}15;
`

const Padding = styled.div`
  width: 100%;
  height: 100%;
  padding: ${props => props.padding};
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
`

const ScrollWrap = styled.div`
  display: inherit;
  overflow-y: auto;
  width: 100%;
  height: ${props => props.height || "100%"};
  
  
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${props => props.theme.mainBg};
  }
`

const SvgWrapper = styled.div`
  width: ${props => props.width || "26px"};
  height: ${props => props.height || "26px"};
  margin: 0 10px;
  cursor: pointer;

  opacity: ${props => props.active ? 1 : 0.5};
`

const Margin = styled.div`
  width: 100%;
  margin: ${props => props.margin};
`

const Decoration = styled(FaSquare)`
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  color: ${props => props.theme.mainOrange};
`;


const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${props => props.active ? props.theme.mainOrange : props.theme.input}95;
  color: #191c20;
  min-width: 100px;
  min-height: 28px;
  font-size: 0.8rem;
  margin: ${props => props.margin || "0 10px"};
  cursor: pointer;
  transition: all 0.3s;

  &:hover{
    background-color: ${props => props.active ? props.theme.mainOrange : props.theme.input};
  }
`

const LoaderContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 8px;
`

const PercentText = styled.div`
  color: ${props => (props.pc < 50 && props.theme.mainRed) ||
    (props.pc < 100 && props.theme.mainOrange) ||
    props.theme.mainGreen
};
`


const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.mainBg};
`

const SubmitSearch = styled(AiOutlineFileSearch)`
  margin: 0 10px;
  height: 22px;
  width: 22px;
  color: ${props => props.theme.color};
  cursor: pointer;
`

const GlobalLoadingWrapper = styled.div`
  position: absolute;
  ${props => props.theme.english && css`
    top: ${props => props.top || "15px"};
    right: ${props => props.left || "40px"};
  `};
  
  ${props => !props.theme.english && css`
    top: ${props => props.top || "20px"};
    left: ${props => props.left || "20px"};
  `};
  
  
`

const Tooltip = styled.div`
  display: ${props => !props.show && "none"};
  position: absolute;
  top: ${props => props.top};
  left: ${props => props.left};
  right: ${props => props.right};
  bottom: ${props => props.bottom};
  padding: 8px;
  background-color: ${props => props.theme.tInputBg};
  color: ${props => props.theme.color};
  font-size: 0.7rem;
  border-radius: 6px;
  border: 2px solid ${props => props.theme.color}50;
`


const TradeAnimation = keyframes`
    0% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
`


const TradeAnimateItem = styled(FlexCenter)`
  position: relative;
  
  ${props => props.animate && css`
    &::after{
      content: ' ';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      animation: ${TradeAnimation} 1.3s ease-in forwards;
      background-color: ${props => props.type === 'buy' ? props.theme.mainGreen : props.theme.mainRed}25;
    }
  `};
`

export const OrderAnimate = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  animation: ${TradeAnimation} 0.5s ease-in forwards;
  background-color: ${props => props.type === 'buy' ? props.theme.mainGreen : props.theme.mainRed}60;
`

const DepositIcon = styled(BiExit)`
  color: ${props => props.type === 'buy' ? props.theme.mainGreen : props.theme.mainRed};
  transition: all 0.2s;
  margin: 0 1px;
  
  ${props => props.theme.english && css`
    transform: rotate(0) translateX(0);
  `};

  ${props => !props.theme.english && css`
    transform: rotate(180deg) translateX(0);
  `};
  
  ${props => props.hovered && css`
    ${props => props.theme.english && css`
      transform: rotate(0) translateX(3px);
    `};

    ${props => !props.theme.english && css`
      transform: rotate(180deg) translateX(3px);
    `};
  `};
`

const IconWrapper = styled.div`
  padding: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  &:hover{
    background-color: ${props => props.theme.hover};
  };
`


export {
  MainBody,
  Flex,
  FlexColumn,
  FlexCenter,
  FlexEnd,
  FlexStart,
  CFlexStart,
  DText,
  HText,
  TradeWrapper,
  CFlexBetween,
  FlexBetween,
  SpinnerContainer,
  CFlexCenter,
  CFlex,
  TradeBoxHeader,
  Padding,
  ScrollWrap,
  SvgWrapper,
  CFlexEnd,
  Margin,
  Decoration,
  Button,
  LoaderContainer,
  PercentText,
  PaginationContainer,
  SubmitSearch,
  GlobalLoadingWrapper,
  InvoiceText,
  Tooltip,
  TradeAnimateItem,
  ColorText,
  DepositIcon,
  IconWrapper
}
